export default [
  { compare: 'SaleComp1' },
  { compare: 'SaleComp2' },
  { compare: 'SaleComp3' },
  { compare: 'ListComp1' },
  { compare: 'ListComp2' },
  { compare: 'ListComp3' },
];
